import { render, staticRenderFns } from "./ChatMessageMenu.vue?vue&type=template&id=123941ee&"
import script from "./ChatMessageMenu.vue?vue&type=script&lang=js&"
export * from "./ChatMessageMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports